module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-407.94ac4bd.woff2";